export default {
  PERM_VIEW_MODULE_PAYMENTS: "Access the payments module",
  PERM_VIEW_ANY_PAYMENTS: "See all payments",
  PERM_VIEW_PAYMENTS: "See payment details",
  PERM_CREATE_PAYMENTS: "Create a payment",
  PERM_VIEW_MODULE_SUBSCRIPTIONS: "Access the subscriptions module",
  PERM_VIEW_ANY_SUBSCRIPTIONS: "See all subscriptions",
  PERM_VIEW_SUBSCRIPTIONS: "See subscription details",
  PERM_CREATE_SUBSCRIPTIONS: "Create a subscription",
  PERM_EDIT_SUBSCRIPTIONS: "Edit subscriptions",
  PERM_DELETE_SUBSCRIPTIONS: "Delete a subscription",
  PERM_VIEW_MODULE_PACKAGES: "Access the packages module",
  PERM_VIEW_ANY_PACKAGES: "See all packages",
  PERM_VIEW_PACKAGES: "See package details",
  PERM_CREATE_PACKAGES: "Create a package",
  PERM_EDIT_PACKAGES: "Edit packages",
  PERM_DELETE_PACKAGES: "Delete a package",
  PERM_VIEW_MODULE_CUSTOMERS: "Access the customers module",
  PERM_VIEW_ANY_CUSTOMERS: "See all customers",
  PERM_VIEW_CUSTOMERS: "See customer details",
  PERM_CREATE_CUSTOMERS: "Create a customer",
  PERM_EDIT_CUSTOMERS: "Edit customers",
  PERM_DELETE_CUSTOMERS: "Delete a customer",
  PERM_VIEW_MODULE_INVOICES: "Access the invoices module",
  PERM_VIEW_ANY_INVOICES: "See all invoices",
  PERM_VIEW_INVOICES: "See invoice details",
  PERM_CREATE_INVOICES: "Create an invoice",
  PERM_EDIT_INVOICES: "Edit invoices",
  PERM_DELETE_INVOICES: "Delete an invoice",
  PERM_VIEW_MODULE_PRODUCTS: "Access the products module",
  PERM_VIEW_ANY_PRODUCTS: "See all products",
  PERM_VIEW_PRODUCTS: "See product details",
  PERM_CREATE_PRODUCTS: "Create a product",
  PERM_EDIT_PRODUCTS: "Edit products",
  PERM_EDIT_OWN_PRODUCTS: "Edit own product",
  PERM_DELETE_PRODUCTS: "Delete products",
  PERM_VIEW_MODULE_ORGANIZATIONS: "Access the organizations module",
  PERM_VIEW_ANY_ORGANIZATIONS: "See all organizations",
  PERM_VIEW_ORGANIZATIONS: "See organization details",
  PERM_CREATE_ORGANIZATIONS: "Create an organization",
  PERM_EDIT_ORGANIZATIONS: "Edit organizations",
  PERM_EDIT_OWN_ORGANIZATIONS: "Edit own organization",
  PERM_DELETE_ORGANIZATIONS: "Delete organizations",
  PERM_VIEW_MODULE_RESELLERS: "Access the resellers module",
  PERM_VIEW_ANY_RESELLERS: "View all resellers",
  PERM_VIEW_RESELLERS: "View resellers details",
  PERM_CREATE_RESELLERS: "Create a reseller",
  PERM_EDIT_RESELLERS: "Edit resellers",
  PERM_EDIT_OWN_RESELLERS: "Edit own reseller",
  PERM_DELETE_RESELLERS: "Delete resellers",
  PERM_VIEW_MODULE_USERS: "Access the users module",
  PERM_VIEW_ANY_USERS: "View all users",
  PERM_VIEW_USERS: "View users details",
  PERM_CREATE_USERS: "Create a user",
  PERM_EDIT_USERS: "Edit users",
  PERM_DELETE_USERS: "Delete users",
  PERM_VIEW_MODULE_ROLES: "Access the roles module",
  PERM_VIEW_ANY_ROLES: "View all roles",
  PERM_VIEW_ROLES: "View roles details",
  PERM_CREATE_ROLES: "Create a role",
  PERM_EDIT_ROLES: "Edit roles",
  PERM_DELETE_ROLES: "Delete roles",
  PERM_VIEW_ANY_PERMISSIONS: "View all permissions",
  PERM_VIEW_PERMISSIONS: "View permissions details",
  PERM_VIEW_ANY_LOGS: "View all logs",
  PERM_VIEW_LOGS: "View log details",
  PERM_EDIT_ORGANIZATION_TEMPLATES: "Edit organization content templates",

  PERM_VIEW_MODULE_TEMPLATES_MAILS: "Access the mail template module",
  PERM_VIEW_ANY_TEMPLATES_MAILS: "View any templates",
  PERM_VIEW_TEMPLATES_MAILS: "View mail template",
  PERM_CREATE_TEMPLATES_MAILS: "Create mail template",
  PERM_EDIT_TEMPLATES_MAILS: "Edit mail template",
  PERM_DELETE_TEMPLATES_MAILS: "Delete mail template",

  PERM_VIEW_MODULE_ELIXIOPAY_TRANSACTIONS: "Access the elixiopay transactions module",
  PERM_VIEW_ANY_ELIXIOPAY_TRANSACTIONS: "View any elixiopay transactions",
  PERM_VIEW_ELIXIOPAY_TRANSACTIONS: "View elixiopay transactions",
  PERM_CREATE_ELIXIOPAY_TRANSACTIONS: "Create elixiopay transactions",
  PERM_EDIT_ELIXIOPAY_TRANSACTIONS: "Edit elixiopay transactions",
  PERM_DELETE_ELIXIOPAY_TRANSACTIONS: "Delete elixiopay transactions",

  PERM_VIEW_MODULE_TAXES: "Access the taxes module",
  PERM_VIEW_ANY_TAXES: "View any taxes",
  PERM_VIEW_TAXES: "View tax details",
  PERM_CREATE_TAXES: "Create taxes",
  PERM_EDIT_TAXES: "Edit taxes",
  PERM_DELETE_TAXES: "Delete taxes",

  PERM_VIEW_APP_DEFAULT: "View default app",
  PERM_VIEW_APP_CRM: "View CRM app",
  PERM_VIEW_APP_SYNC: "View Sync app",
  PERM_VIEW_APP_ESIGN: "View e-sign app",
  PERM_VIEW_APP_DPA: "View DPA/PPA app",
  PERM_VIEW_APP_SALES: "View sales app",
  PERM_VIEW_APP_PURCHASES: "View purchases app",
  PERM_VIEW_APP_INVENTORY: "View inventory app",
  PERM_VIEW_APP_FILE_EXPLORER: "View file explorer app",
  PERM_VIEW_APP_RESELLER: "View reseller app",
  PERM_VIEW_APP_ADMIN: "View admin app",
  PERM_VIEW_APP_WALLET: "View wallet",
  PERM_VIEW_APP_AUCTION: "View auction app",

  PERM_VIEW_MODULE_CONTACTS: "Access the contacts module",
  PERM_VIEW_ANY_CONTACTS: "View all contacts",
  PERM_VIEW_CONTACTS: "View contact details",
  PERM_CREATE_CONTACTS: "Create a contact",
  PERM_EDIT_CONTACTS: "Edit contacts",
  PERM_DELETE_CONTACTS: "Delete a contact",

  PERM_VIEW_MODULE_SUPPLIERS: "Access the suppliers module",
  PERM_VIEW_ANY_SUPPLIERS: "View all suppliers",
  PERM_VIEW_SUPPLIERS: "View supplier details",
  PERM_CREATE_SUPPLIERS: "Create a supplier",
  PERM_EDIT_SUPPLIERS: "Edit suppliers",
  PERM_DELETE_SUPPLIERS: "Delete a supplier",

  PERM_VIEW_MODULE_LOCATIONS: "Access the locations module",
  PERM_VIEW_ANY_LOCATIONS: "View all locations",
  PERM_VIEW_LOCATIONS: "View location details",
  PERM_CREATE_LOCATIONS: "Create a location",
  PERM_EDIT_LOCATIONS: "Edit locations",
  PERM_EDIT_HIS_LOCATIONS: "Edit own location",
  PERM_DELETE_LOCATIONS: "Delete a location",

  PERM_VIEW_MODULE_FILES: "Access the files module",
  PERM_VIEW_ANY_FILES: "View all files",
  PERM_VIEW_FILES: "View file details",
  PERM_CREATE_FILES: "Create a file",
  PERM_EDIT_FILES: "Edit files",
  PERM_DELETE_FILES: "Delete a file",
  PERM_MANAGE_ACCESS_FILES: "Manage file permissions",

  PERM_VIEW_MODULE_FOLDERS: "Access the folders module",
  PERM_VIEW_ANY_FOLDERS: "View all folders",
  PERM_VIEW_FOLDERS: "View folder details",
  PERM_CREATE_FOLDERS: "Create a folder",
  PERM_EDIT_FOLDERS: "Edit folders",
  PERM_DELETE_FOLDERS: "Delete a folder",
  PERM_MANAGE_ACCESS_FOLDERS: "Manage folder permissions",
  PERM_MANAGE_LOCKED_FOLDERS: "Manage system folders",

  PERM_VIEW_MODULE_WAREHOUSES: "Access the warehouses module",
  PERM_VIEW_ANY_WAREHOUSES: "View all warehouses",
  PERM_VIEW_WAREHOUSES: "View warehouse details",
  PERM_CREATE_WAREHOUSES: "Create a warehouse",
  PERM_EDIT_WAREHOUSES: "Edit warehouses",
  PERM_DELETE_WAREHOUSES: "Delete a warehouse",

  PERM_VIEW_MODULE_PURCHASES_ORDERS: "Access the purchase orders module",
  PERM_VIEW_ANY_PURCHASES_ORDERS: "View all purchase orders",
  PERM_VIEW_PURCHASES_ORDERS: "View purchase order details",
  PERM_CREATE_PURCHASES_ORDERS: "Create a purchase order",
  PERM_EDIT_PURCHASES_ORDERS: "Edit purchase orders",
  PERM_DELETE_PURCHASES_ORDERS: "Delete a purchase order",

  PERM_VIEW_MODULE_PURCHASES_INVOICES: "Access the purchase invoices module",
  PERM_VIEW_ANY_PURCHASES_INVOICES: "View all purchase invoices",
  PERM_VIEW_PURCHASES_INVOICES: "View purchase invoice details",
  PERM_CREATE_PURCHASES_INVOICES: "Create a purchase invoice",
  PERM_EDIT_PURCHASES_INVOICES: "Edit purchase invoices",
  PERM_DELETE_PURCHASES_INVOICES: "Delete a purchase invoice",

  PERM_VIEW_MODULE_PURCHASES_DELIVERIES: "Access the purchase deliveries module",
  PERM_VIEW_ANY_PURCHASES_DELIVERIES: "View all purchase deliveries",
  PERM_VIEW_PURCHASES_DELIVERIES: "View purchase delivery details",
  PERM_CREATE_PURCHASES_DELIVERIES: "Create a purchase delivery",
  PERM_EDIT_PURCHASES_DELIVERIES: "Edit purchase deliveries",
  PERM_DELETE_PURCHASES_DELIVERIES: "Delete a purchase delivery",

  PERM_VIEW_MODULE_PURCHASES_PAYMENTS: "Access the purchase payments module",
  PERM_VIEW_ANY_PURCHASES_PAYMENTS: "View all purchase payments",
  PERM_VIEW_PURCHASES_PAYMENTS: "View purchase payment details",
  PERM_CREATE_PURCHASES_PAYMENTS: "Create a purchase payment",
  PERM_EDIT_PURCHASES_PAYMENTS: "Edit purchase payments",
  PERM_DELETE_PURCHASES_PAYMENTS: "Delete a purchase payment",

  PERM_VIEW_MODULE_SALES_ORDERS: "Access the sales orders module",
  PERM_VIEW_ANY_SALES_ORDERS: "View all sales orders",
  PERM_VIEW_SALES_ORDERS: "View sales order details",
  PERM_CREATE_SALES_ORDERS: "Create a sales order",
  PERM_EDIT_SALES_ORDERS: "Edit sales orders",
  PERM_DELETE_SALES_ORDERS: "Delete a sales order",

  PERM_VIEW_MODULE_SALES_INVOICES: "Access the sales invoices module",
  PERM_VIEW_ANY_SALES_INVOICES: "View all sales invoices",
  PERM_VIEW_SALES_INVOICES: "View sales invoice details",
  PERM_CREATE_SALES_INVOICES: "Create a sales invoice",
  PERM_EDIT_SALES_INVOICES: "Edit sales invoices",
  PERM_DELETE_SALES_INVOICES: "Delete a sales invoice",

  PERM_VIEW_MODULE_SALES_DELIVERIES: "Access the sales deliveries module",
  PERM_VIEW_ANY_SALES_DELIVERIES: "View all sales deliveries",
  PERM_VIEW_SALES_DELIVERIES: "View sales delivery details",
  PERM_CREATE_SALES_DELIVERIES: "Create a sales delivery",
  PERM_EDIT_SALES_DELIVERIES: "Edit sales deliveries",
  PERM_DELETE_SALES_DELIVERIES: "Delete a sales delivery",

  PERM_VIEW_MODULE_SALES_PAYMENTS: "Access the sales payments module",
  PERM_VIEW_ANY_SALES_PAYMENTS: "View all sales payments",
  PERM_VIEW_SALES_PAYMENTS: "View sales payment details",
  PERM_CREATE_SALES_PAYMENTS: "Create a sales payment",
  PERM_EDIT_SALES_PAYMENTS: "Edit sales payments",
  PERM_DELETE_SALES_PAYMENTS: "Delete a sales payment",

  PERM_VIEW_MODULE_RESELLER_PRODUCTS: "Access the reseller products module",
  PERM_VIEW_ANY_RESELLER_PRODUCTS: "View all reseller products",
  PERM_VIEW_RESELLER_PRODUCTS: "View reseller product details",
  PERM_CREATE_RESELLER_PRODUCTS: "Create a reseller product",
  PERM_EDIT_RESELLER_PRODUCTS: "Edit reseller products",
  PERM_DELETE_RESELLER_PRODUCTS: "Delete a reseller product",

  PERM_VIEW_MODULE_RESELLER_SERVICES: "Access the reseller services module",
  PERM_VIEW_ANY_RESELLER_SERVICES: "View all reseller services",
  PERM_VIEW_RESELLER_SERVICES: "View reseller service details",
  PERM_CREATE_RESELLER_SERVICES: "Create a reseller service",
  PERM_EDIT_RESELLER_SERVICES: "Edit reseller services",
  PERM_DELETE_RESELLER_SERVICES: "Delete a reseller service",

  PERM_VIEW_MODULE_RESELLER_INVOICES: "Access the reseller invoices module",
  PERM_VIEW_ANY_RESELLER_INVOICES: "View all reseller invoices",
  PERM_VIEW_RESELLER_INVOICES: "View reseller invoice details",
  PERM_CREATE_RESELLER_INVOICES: "Create a reseller invoice",
  PERM_EDIT_RESELLER_INVOICES: "Edit reseller invoices",
  PERM_DELETE_RESELLER_INVOICES: "Delete a reseller invoice",

  PERM_VIEW_MODULE_RESELLER_PAYMENTS: "Access the reseller payments module",
  PERM_VIEW_ANY_RESELLER_PAYMENTS: "View all reseller payments",
  PERM_VIEW_RESELLER_PAYMENTS: "View reseller payment details",
  PERM_CREATE_RESELLER_PAYMENTS: "Create a reseller payment",

  PERM_VIEW_MODULE_STOCK_MOVEMENTS: "Access the stock movements module",
  PERM_VIEW_ANY_STOCK_MOVEMENTS: "View all stock movements",
  PERM_VIEW_STOCK_MOVEMENTS: "View stock movement details",
  PERM_CREATE_STOCK_MOVEMENTS: "Create a stock movement",
  PERM_EDIT_STOCK_MOVEMENTS: "Edit stock movements",
  PERM_DELETE_STOCK_MOVEMENTS: "Delete a stock movement",

  PERM_VIEW_MODULE_IMPORTS: "Access the imports module",
  PERM_VIEW_ANY_IMPORTS: "View all imports",
  PERM_VIEW_IMPORTS: "View import details",
  PERM_CREATE_IMPORTS: "Create an import",
  PERM_EDIT_IMPORTS: "Edit imports",
  PERM_DELETE_IMPORTS: "Delete an import",

  PERM_VIEW_MODULE_CONTRACTS: "Access the signature templates module",
  PERM_VIEW_ANY_CONTRACTS: "View all signature templates",
  PERM_VIEW_CONTRACTS: "View signature template details",
  PERM_CREATE_CONTRACTS: "Create a signature template",
  PERM_EDIT_CONTRACTS: "Edit signature templates",
  PERM_DELETE_CONTRACTS: "Delete a signature template",

  PERM_VIEW_MODULE_CONTRACTFILES: "Access the signature template documents module",
  PERM_VIEW_ANY_CONTRACTFILES: "View all signature template documents",
  PERM_VIEW_CONTRACTFILES: "View signature template document details",
  PERM_CREATE_CONTRACTFILES: "Create a signature template document",
  PERM_EDIT_CONTRACTFILES: "Edit signature template documents",
  PERM_DELETE_CONTRACTFILES: "Delete a signature template document",

  PERM_VIEW_MODULE_SIGNATURES: "Access the signatures module",
  PERM_VIEW_ANY_SIGNATURES: "View all signatures",
  PERM_VIEW_SIGNATURES: "View signature details",
  PERM_CREATE_SIGNATURES: "Create a signature",
  PERM_EDIT_SIGNATURES: "Edit signatures",
  PERM_DELETE_SIGNATURES: "Delete a signature",

  PERM_VIEW_MODULE_ESIGNS: "Access the e-sign module",
  PERM_VIEW_ANY_ESIGNS: "View all e-sign packages",
  PERM_VIEW_ESIGNS: "View e-sign package details",
  PERM_CREATE_ESIGNS: "Create an e-sign package",
  PERM_EDIT_ESIGNS: "Edit e-sign packages",
  PERM_DELETE_ESIGNS: "Delete an e-sign package",

  PERM_VIEW_MODULE_SYNC_LOGS: "Access the sync logs module",
  PERM_VIEW_ANY_SYNC_LOGS: "View all sync logs",
  PERM_VIEW_SYNC_LOGS: "View sync log details",
  PERM_CREATE_SYNC_LOGS: "Create a sync log",
  PERM_EDIT_SYNC_LOGS: "Edit sync logs",
  PERM_DELETE_SYNC_LOGS: "Delete a sync log",

  PERM_VIEW_MODULE_NUVEI_CARDS: "Access the payment methods module",
  PERM_VIEW_ANY_NUVEI_CARDS: "View all payment methods",
  PERM_VIEW_NUVEI_CARDS: "View payment method details",
  PERM_CREATE_NUVEI_CARDS: "Create a payment method",
  PERM_EDIT_NUVEI_CARDS: "Edit payment methods",
  PERM_DELETE_NUVEI_CARDS: "Delete a payment method",

  PERM_VIEW_MODULE_NUVEI_TRANSACTIONS: "Access the Nuvei transactions module",
  PERM_VIEW_ANY_NUVEI_TRANSACTIONS: "View all Nuvei transactions",
  PERM_VIEW_NUVEI_TRANSACTIONS: "View Nuvei transaction details",
  PERM_CREATE_NUVEI_TRANSACTIONS: "Create a Nuvei transaction",
  PERM_EDIT_NUVEI_TRANSACTIONS: "Edit Nuvei transactions",
  PERM_DELETE_NUVEI_TRANSACTIONS: "Delete a Nuvei transaction",

  PERM_VIEW_MODULE_DPAPAYMENTS: "Access the DPA payments module",
  PERM_VIEW_ANY_DPAPAYMENTS: "View all DPA payments",

  PERM_VIEW_WALLETS_DPAPAYMENTS: "View wallets",
  PERM_CREATE_WALLETS_DPAPAYMENTS: "Create wallets",
  PERM_EDIT_WALLETS_DPAPAYMENTS: "Edit wallets",
  PERM_DELETE_WALLETS_DPAPAYMENTS: "Delete wallets",
  DEPOSIT_FUNDS_DPAPAYMENTS: "Create a deposit payment",
  WITHDRAW_FUNDS_DPAPAYMENTS: "Create a withdrawal payment",
  TRANSFER_FUNDS_DPAPAYMENTS: "Create a transfer payment",
  VALIDATE_TRANSACTION_DPAPAYMENTS: "Validate a payment",
  PERM_VIEW_PAYMENTMETHOD_DPAPAYMENTS: "View payment methods",
  PERM_CREATE_PAYMENTMETHOD_DPAPAYMENTS: "Create payment methods",
  PERM_UPDATE_PAYMENTMETHOD_DPAPAYMENTS: "Edit payment methods",
  PERM_DELETE_PAYMENTMETHOD_DPAPAYMENTS: "Delete payment methods",

  PERM_VIEW_MODULE_DPA_ACCOUNTS: "Access the DPA accounts module",
  PERM_VIEW_ANY_DPA_ACCOUNTS: "View all DPA accounts",
  PERM_VIEW_DPA_ACCOUNTS: "View DPA account details",
  PERM_CREATE_DPA_ACCOUNTS: "Create a DPA account",
  PERM_EDIT_DPA_ACCOUNTS: "Edit DPA accounts",
  PERM_DELETE_DPA_ACCOUNTS: "Delete DPA accounts",

  PERM_VIEW_MODULE_DPATRANSACTIONS: "Access the DPA transactions module",
  PERM_VIEW_ANY_DPATRANSACTIONS: "View all DPA transactions",
  PERM_VIEW_DPATRANSACTIONS: "View DPA transaction details",
  PERM_CREATE_DPATRANSACTIONS: "Create a DPA transaction",
  PERM_EDIT_DPATRANSACTIONS: "Edit DPA transactions",
  PERM_DELETE_DPATRANSACTIONS: "Delete DPA transactions",

  PERM_EDIT_HIS_ORGANIZATIONS: "Edit own organization",

  PERM_VIEW_MODULE_PROPERTIES: "Access the properties module",
  PERM_VIEW_ANY_PROPERTIES: "View all properties",
  PERM_VIEW_PROPERTIES: "View property details",
  PERM_CREATE_PROPERTIES: "Create a property",
  PERM_EDIT_PROPERTIES: "Edit properties",
  PERM_DELETE_PROPERTIES: "Delete properties",
  PERM_TOGGLE_ACTIVATION_PROPERTIES: "Activate/Deactivate a property",
  PERM_ACCESS_ALL_FIELDS_PROPERTIES: "Access all property fields",
  PERM_EXPORTS_PROPERTIES: "Export properties",
  PERM_SYNC_PROPERTIES: "Import properties",
  PERM_EDIT_PROPERTY_NUMBER_PROPERTIES: "Edit property number",
  PERM_CHANGE_APPROVED_STATUS_PROPERTIES: "Change approved property status",

  PERM_VIEW_MODULE_AUCTIONS: "Access the auctions module",
  PERM_VIEW_ANY_AUCTIONS: "View all auctions",
  PERM_VIEW_AUCTIONS: "View auction details",
  PERM_CREATE_AUCTIONS: "Create an auction",
  PERM_EDIT_AUCTIONS: "Edit auctions",
  PERM_DELETE_AUCTIONS: "Delete auctions",

  PERM_VIEW_ANY_TRANSACTIONS_PROPERTIES: "View all property transactions",
  PERM_CREATE_TRANSACTIONS_PROPERTIES: "Create a property transaction",
  PERM_DELETE_TRANSACTIONS_PROPERTIES: "Delete property transactions",
  PERM_VIEW_MODULE_PROPERTY_TRANSACTIONS: "Access the property transactions module",
  PERM_VIEW_ANY_PROPERTY_TRANSACTIONS: "View all property transactions",
  PERM_VIEW_PROPERTY_TRANSACTIONS: "View property transaction details",
  PERM_CREATE_PROPERTY_TRANSACTIONS: "Create a property transaction",

  PERM_VIEW_MODULE_OTHER_FEES: "Access the other fees module",
  PERM_VIEW_ANY_OTHER_FEES: "View all other fees",
  PERM_VIEW_OTHER_FEES: "View other fee details",
  PERM_CREATE_OTHER_FEES: "Create a fee",
  PERM_EDIT_OTHER_FEES: "Edit other fees",
  PERM_DELETE_OTHER_FEES: "Delete a fee",

  PERM_VIEW_MODULE_THIRD_PARTY_SERVICES: "Access the third-party services module",
  PERM_VIEW_ANY_THIRD_PARTY_SERVICES: "View all third-party services",
  PERM_VIEW_THIRD_PARTY_SERVICES: "View third-party service details",
  PERM_CREATE_THIRD_PARTY_SERVICES: "Create a third-party service",
  PERM_EDIT_THIRD_PARTY_SERVICES: "Edit third-party services",
  PERM_DELETE_THIRD_PARTY_SERVICES: "Delete a third-party service",

  PERM_VIEW_MODULE_WORKSPACE_MEMBERS: "Access the workspace members module",
  PERM_VIEW_ANY_WORKSPACE_MEMBERS: "View all workspace members",
  PERM_VIEW_WORKSPACE_MEMBERS: "View workspace member details",
  PERM_CREATE_WORKSPACE_MEMBERS: "Add a workspace member",
  PERM_EDIT_WORKSPACE_MEMBERS: "Edit workspace members",
  PERM_DELETE_WORKSPACE_MEMBERS: "Remove a workspace member",

  PERM_VIEW_MODULE_WORKSPACE_CUSTOMERS: "Access the workspace customers module",
  PERM_VIEW_ANY_WORKSPACE_CUSTOMERS: "View all workspace customers",
  PERM_VIEW_WORKSPACE_CUSTOMERS: "View workspace customer details",
  PERM_CREATE_WORKSPACE_CUSTOMERS: "Add a workspace customer",
  PERM_EDIT_WORKSPACE_CUSTOMERS: "Edit workspace customers",
  PERM_DELETE_WORKSPACE_CUSTOMERS: "Remove a workspace customer",

  PERM_WORKSPACE_ADMIN: "Workspace administrator",

  PERM_VIEW_MODULE_CATEGORIES: "Access the categories module",
  PERM_VIEW_ANY_CATEGORIES: "View all categories",
  PERM_VIEW_CATEGORIES: "View category details",
  PERM_CREATE_CATEGORIES: "Create a category",
  PERM_EDIT_CATEGORIES: "Edit categories",
  PERM_DELETE_CATEGORIES: "Delete a category",

  PERM_VIEW_MODULE_OPTIONS: "Access the options module",
  PERM_VIEW_ANY_OPTIONS: "View all options",
  PERM_EDIT_OPTIONS: "Edit options",

  PERM_VIEW_ANY_MAIL_TEMPLATE_VARIABLES: "View all mail template variables",
  PERM_VIEW_MAIL_TEMPLATE_VARIABLES: "View mail template variable details",
  PERM_CREATE_MAIL_TEMPLATE_VARIABLES: "Create a mail template variable",
  PERM_EDIT_MAIL_TEMPLATE_VARIABLES: "Edit mail template variables",
  PERM_DELETE_MAIL_TEMPLATE_VARIABLES: "Delete a mail template variable",

  PERM_CREATE_TYPE_MAILS: "Create a mail type",
  PERM_EDIT_TYPE_MAILS: "Edit mail types",
  PERM_DELETE_TYPE_MAILS: "Delete a mail type",
};
